const l = {
  base: 16,
  lg: 40,
  xl: 152
}, s = {
  mobile: {
    xs: 608,
    sm: 608,
    md: 688,
    mdx: 736,
    lg: 688,
    xl: 1136,
    global: 1296
  },
  desktop: {
    xs: 608,
    sm: 750,
    md: 830,
    mdx: 878,
    lg: 942,
    xl: 1136,
    global: 1296
  }
}, b = (e) => {
  let o = "global";
  const x = {
    xs: {
      base: s.mobile.xs + l.base * 2,
      lg: s.desktop.xs + l.lg * 2,
      xl: s.desktop.xs + l.xl * 2
    },
    sm: {
      base: s.mobile.sm + l.base * 2,
      lg: s.desktop.sm + l.lg * 2,
      xl: s.desktop.sm + l.xl * 2
    },
    md: {
      base: s.mobile.md + l.base * 2,
      lg: s.desktop.md + l.lg * 2,
      xl: s.desktop.md + l.xl * 2
    },
    mdx: {
      base: s.mobile.mdx + l.base * 2,
      lg: s.desktop.mdx + l.lg * 2,
      xl: s.desktop.mdx + l.xl * 2
    },
    lg: {
      base: s.mobile.lg + l.base * 2,
      lg: s.desktop.lg + l.lg * 2,
      xl: s.desktop.lg + l.xl * 2
    },
    xl: {
      base: s.mobile.xl + l.base * 2,
      lg: s.desktop.xl + l.lg * 2,
      xl: s.desktop.xl + l.xl * 2
    },
    global: {
      base: s.mobile.global + l.base * 2,
      lg: s.desktop.global + l.lg * 2,
      xl: s.desktop.global + l.xl * 2
    }
  };
  return o = {
    base: x[e || "xl"].base + 2,
    xs: x[e || "xl"].base + 2,
    sm: x[e || "xl"].base + 2,
    md: x[e || "xl"].base + 2,
    lg: x[e || "xl"].lg + 2,
    xl: x[e || "xl"].xl + 2
  }, o;
};
export {
  l as PADDING_SIZES,
  b as resolveSize
};
